const borderColors = { green: '#00D170', blue: '#001FE6', red: '#E01507', lightBlue: '#7A8CFF' };

export const PROD_ENVIRONMENTS = [
  {
    title: 'PROD',
    url: 'https://app-bandplay-ctv.azurewebsites.net/',
    description: '',
    borderColor: '',
  },
  {
    title: 'PRE-PROD',
    url: 'http://app-bandplay-ctv-pre-prod.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: '',
    borderColor: '',
  },
];

export const QA_ENVIRONMENTS = [
  {
    title: 'HML',
    url: 'http://app-bandplay-ctv-hml.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: '',
    borderColor: borderColors.red,
  },
  {
    title: 'BETA',
    url: 'http://app-bandplay-ctv-beta.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'On hold',
    borderColor: borderColors.red,
  },
];

export const DEV_ENVIRONMENTS = [
  {
    title: 'VED1',
    url: 'http://app-bandplay-ctv-ved1.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'QA I',
    borderColor: '',
  },
  {
    title: 'VED2',
    url: 'http://app-bandplay-ctv-ved2.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Sala Digital',
    borderColor: borderColors.red,
  },
  {
    title: 'VED3',
    url: 'http://app-bandplay-ctv-ved3.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'QA II',
    borderColor: '',
  },
  {
    title: 'VED4',
    url: 'http://app-bandplay-ctv-ved4.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Wellington',
    borderColor: borderColors.green,
  },
  {
    title: 'VED5',
    url: 'http://app-bandplay-ctv-ved5.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Paulo',
    borderColor: borderColors.green,
  },
  {
    title: 'VED6',
    url: 'http://app-bandplay-ctv-ved6.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Aline',
    borderColor: borderColors.green,
  },
  {
    title: 'VED7',
    url: 'http://app-bandplay-ctv-ved7.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Extra III',
    borderColor: '',
  },
  {
    title: 'VED8',
    url: 'http://app-bandplay-ctv-ved8.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Mikael',
    borderColor: borderColors.green,
  },
  {
    title: 'VED9',
    url: 'http://app-bandplay-ctv-ved9.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Extra I',
    borderColor: borderColors.green,
  },
  {
    title: 'VED10',
    url: 'http://app-bandplay-ctv-ved10.ambitiousdune-7615a25b.brazilsouth.azurecontainerapps.io',
    description: 'Extra II',
    borderColor: borderColors.red,
  },
];
